<template>
    <div>
        <div class="toolbar">
            <div class="left-items">
                <a-button
                    class="item"
                    icon="icon icon-home"
                    @click="on_reset"
                />

                <a-button
                    class="item"
                    icon="icon icon-jiarucopy"
                    @click="on_create()"
                    type="primary"
                />

                <a-button
                    class="item"
                    ref="refresh"
                    icon="icon icon-reset"
                    @click="load()"
                />
            </div>

            <div class="right-items"></div>
        </div>

        <div class="main">
            <a-table
                :columns="columns"
                :dataSource="data_source"
                rowKey="id"
                :loading="loading"
                :pagination="pagination"
                @change="on_pagination_change"
                :row-selection="{
                    selectedRowKeys: selected_row_keys,
                    onChange: on_selection_change
                }"
                size="middle"
            >
                <template slot="avatar_render" slot-scope="text, record">
                    <img v-if="text" :src="text" class="avatar" />
                </template>

                <template slot="banner_render" slot-scope="text, record">
                    <img v-if="text" :src="text" class="banner" />
                </template>

                <!-- 创建时间 -->
                <template slot="created_render" slot-scope="text, record">
                    <span
                        v-html="
                            $options.filters['friendly'](
                                moment(text * 1000).format('YYYY-MM-DD HH:mm')
                            )
                        "
                    ></span>
                </template>

                <!-- 操作 -->
                <template slot="operation" slot-scope="text, record">
                    <div class="operation">
                        <a-button
                            size="small"
                            @click="on_delete(record)"
                            type="danger"
                            >删除</a-button
                        >
                    </div>
                </template>
            </a-table>

            <div class="explain-block">
                                <a-divider />

                <h2><a-icon type="info-circle" style="margin-right:12px"/>使用说明</h2>

                <a-alert
                    message="请注意，IP白名单仅在【通用设置】>【启用登录限制】启用的情况下才会生效。"
                    style="margin-bottom:24px;"
                    show-icon
                    type="info"
                />

                <ul>
                    <li>
                        添加客户端的外网IP，启用登录限制将会拒绝非白名单IP登录系统，有效保护数据安全。
                    </li>
                    <li>登录限制对管理员账户同样生效。</li>
                </ul>
            </div>
        </div>

        <modal_create
            :visible="visible_create"
            @load="load"
            @close="visible_create = false"
            :record="selected_record"
        />
    </div>
</template>

<script>
import modal_create from "./modal_create.vue";
import moment from "moment";
import common_pagination from "../../../mixins/common_pagination.js";

export default {
    mixins: [common_pagination],
    components: {
        modal_create
    },
    data() {
        return {
            path: "/setting/ip_whitelist",
            data_source: [],
            loading: false,
            visible_create: false,
            selected_record: null,
            wd: null,
            columns: [
                {
                    dataIndex: "ip",
                    width: 150,
                    title: "IP地址"
                },
                {
                    dataIndex: "remark",
                    title: "备注"
                },
                {
                    dataIndex: "last_visited_at",
                    title: "最后访问时间",
                    width: 150,
                    customRender: e =>
                        e ? moment(text * 1000).format("YYYY-MM-DD HH:mm") : ""
                },
                {
                    dataIndex: "created_at",
                    title: "创建时间",
                    width: 150,
                    scopedSlots: {
                        customRender: "created_render"
                    }
                },
                {
                    dataIndex: "operation",
                    title: "操作",
                    align: "center",
                    width: 120,
                    scopedSlots: {
                        customRender: "operation"
                    }
                }
            ]
        };
    },
    mounted() {
        this.load();
    },
    methods: {
        moment,
        load() {
            this.loading = true;

            let new_query = JSON.parse(JSON.stringify(this.$route.query));
            this.$http
                .get(`/setting/ip_whitelist?${this.objectToQuery(new_query)}`)
                .then(res => {
                    if (res.success) {
                        this.data_source = res.data;
                        this.pagination = {
                            pageSize: res.pagination.per_page,
                            total: res.pagination.total,
                            current: res.pagination.current_page
                        };
                    }
                })
                .catch(() => {})
                .then(() => {
                    this.loading = false;
                });
        },
        on_create() {
            this.selected_record = {};
            this.visible_create = true;
        },
        on_delete(record) {
            this.$confirm({
                centered: true,
                title: "删除确认",
                content: `是否删除【${record.ip}】`,
                loading: true,
                onOk: () => {
                    return new Promise((resolve, reject) => {
                        this.$http
                            .delete("/setting/ip_whitelist/" + record.id)
                            .then(res => {
                                if (!res.success) {
                                    this.$error({
                                        title: "失败",
                                        content: res.message
                                    });
                                } else {
                                    this.load();
                                }
                            })
                            .catch(() => {})
                            .then(() => {
                                resolve();
                            });
                    }).catch();
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
.avatar {
    width: 30px;
    height: 30px;
    border-radius: 50%;
}
.banner {
    max-height: 30px;
}
.operation {
    width: 120px;
}
</style>